module.exports = __webpack_public_path__ + "media/bootstrap-icons/star-half-ac037753.svg";